import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_Variable } from '../../../../../_entity/variable/ModuleFE_Variable.js';
import './Renderer_VariableHeader.scss';
export class Renderer_VariableHeader extends ComponentSync {
    __onVariableUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.variable?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ variable: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.variable?._id)
            state.variable = ModuleFE_Variable.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'variable-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'variable-header__title', children: this.state.variable?.name ?? 'N/A' });
    };
    render_Subtitle = () => {
        const variable = this.state.variable;
        if (!variable?.type)
            return;
        return _jsx("span", { className: 'variable-header__sub-title', children: variable.type });
    };
}
//# sourceMappingURL=Renderer_VariableHeader.js.map